/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-param-reassign */
import {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { Icon } from '@jutro/components';
import styles from '../../../SpaAndWellCommonStyles.module.scss'
import metadata from './ServiceTable.metadata.json5';
import OpeEstSearchComponent from '../OperationsEstheticsSearch/OpeEstSearchComponent';

function ServiceTable(props) {

    const {
        data: servicesOfferedVM,
        updateWizardData,
        submissionVM,
        serOffPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addSerTab = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            servicesOfferedVM.value = servicesOfferedVM.value || []

            const { _xCenter, _dtoName } = servicesOfferedVM;

            const EmpInfoObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            EmpInfoObjVM.isValidationReq = true;
            EmpInfoObjVM.fie2 = servicesOfferedVM?.value?.length + 1;

            servicesOfferedVM.pushElement(
                EmpInfoObjVM
            );
            updateWizardData(submissionVM);
        },
        [servicesOfferedVM, viewModelService, updateWizardData, submissionVM]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const setSubmission = useCallback((submissionVM) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);

        updateWizardData(newSubmissionVM);
    });


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            servicesOfferedVM.value.splice(index, 1);

            servicesOfferedVM.value.map((service) => {
                if (service.fie2 > index) {
                    service.fie2 = service.fie2 - 1;
                }
            })

            _.set(submissionVM.value, serOffPath, servicesOfferedVM.value);
            updateWizardData(submissionVM);
        }, [servicesOfferedVM.value, submissionVM, serOffPath, updateWizardData]
    );

    const isOthOperationSelected = (index) => {
        let othSelected = false;

        if (servicesOfferedVM.value[index].opeFie === 'Other'
            || servicesOfferedVM.value[index].opeFie === 'Autre') {
            othSelected = true;
        }

        return othSelected;
    }


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'fie2') {
                const value = item.fie2 ? item.fie2 : index + 1;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'opeFie') {
                const pathUpdated = `${serOffPath}.children[${index}]`;

                return (

                    <OpeEstSearchComponent
                        id={index + path}
                        updateWizardData={updateWizardData}
                        index={index}
                        viewModelService={viewModelService}
                        submissionVM={submissionVM}
                        pathUpdated={pathUpdated}
                        setSubmission={setSubmission}
                     />

                );
            }

            if (path === 'estClaFie') {
                const value = item.estClaFie ? item.estClaFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.estClaFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'ifOthexpFie') {
                const value = item.ifOthexpFie ? item.ifOthexpFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.ifOthexpFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={!_.isUndefined(servicesOfferedVM.value[index].opeFie) &&
                            (servicesOfferedVM.value[index].opeFie === 'Other' || servicesOfferedVM.value[index].opeFie === 'Autre')
                            ? value : undefined}
                        readOnly = {!isOthOperationSelected(index)}
                    />
                );
            }

            if (path === 'estGroAnnRecFie') {
                const value = item.estGroAnnRecFie ? item.estGroAnnRecFie : 0;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.estGroAnnRecFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [handleValueChange])

    const removeSerOffTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`ServicesOfferedTable`]: {
            data: servicesOfferedVM?.value?.sort((a,b) => a.fie2 - b.fie2)
        }

    }), [servicesOfferedVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addSerTab,
            getTableCell,
            removeSerOffTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.componentContent,
            servicesOfferedVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [servicesOfferedVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={servicesOfferedVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ServiceTable.propTypes = wizardProps;
export default withRouter(ServiceTable);
